import { Link } from "react-router-dom";
import { Home, LayoutGrid, MessageSquare } from "lucide-react";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export function NotFoundPage() {
  useDocumentMeta("Page Not Found | The Planet", "The page you're looking for could not be found.");

  return (
    <div className="grid-backdrop relative flex min-h-[70vh] items-center justify-center px-5 py-20">
      <div className="relative text-center">
        <svg width="120" height="120" viewBox="0 0 120 120" className="mx-auto mb-8" aria-hidden="true">
          <circle cx="60" cy="60" r="46" stroke="rgba(111,151,255,0.25)" strokeWidth="1" fill="none" />
          <circle cx="60" cy="60" r="6" fill="#25C7FF" />
          <circle cx="94" cy="34" r="4" fill="#397BFF" opacity="0.5" />
          <line x1="60" y1="60" x2="94" y2="34" stroke="#EF5B67" strokeWidth="1.2" strokeDasharray="4 4" />
        </svg>
        <h1 className="font-display text-3xl font-semibold text-text-primary sm:text-4xl">
          This Server Route Could Not Be Found
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-text-secondary">
          The page may have moved, the address may be incorrect, or the requested resource may no
          longer be available.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link to="/" className="focus-ring inline-flex items-center gap-2 rounded-full bg-gradient-brand px-5 py-3 text-sm font-medium text-white transition hover:brightness-110">
            <Home className="h-4 w-4" /> Return Home
          </Link>
          <Link to="/#products" className="focus-ring inline-flex items-center gap-2 rounded-full border border-border px-5 py-3 text-sm font-medium text-text-primary transition hover:border-cyan/50">
            <LayoutGrid className="h-4 w-4" /> Explore Products
          </Link>
          <Link to="/contact" className="focus-ring inline-flex items-center gap-2 rounded-full border border-border px-5 py-3 text-sm font-medium text-text-primary transition hover:border-cyan/50">
            <MessageSquare className="h-4 w-4" /> Contact Support
          </Link>
        </div>
      </div>
    </div>
  );
}
